import ByteUtils from './ByteUtils';

const PACKET_TYPE_LENGTH = 1;
const FILE_HASH_LENGTH = 4;
const SEQUENCE_NUMBER_LENGTH = 4;
const TYPE_METADATA_LENGTH = 50;
const TITLE_METADATA_MAX_LENGTH = 100;

class Packet {
  packetType;
  fileHash;
  sequenceNumber;
  data;

  constructor() {
    this.fileHash = 0;
    this.sequenceNumber = 0;
    this.data = new ArrayBuffer(0);
  }

  static packetTypes = {
    INITIAL_PACKET: 0,
    DATA_PACKET: 1,
    ACK_PACKET: 2,
    EOF_PACKET: 3,
  };

  equals(other) {
    if (
      other === null ||
      this.packetType !== other.packetType ||
      this.fileHash !== other.fileHash ||
      this.sequenceNumber !== other.sequenceNumber ||
      this.data.byteLength !== other.data.byteLength
    ) {
      return false;
    }

    const thisView = new DataView(this.data);
    const otherView = new DataView(other.data);

    for (let i = 0; i < this.data.byteLength; i++) {
      if (thisView.getUint8(i) !== otherView.getUint8(i)) {
        return false;
      }
    }

    return true;
  }

  toArrayBuffer() {
    console.log(
      'toArrayBuffer',
      PACKET_TYPE_LENGTH,
      FILE_HASH_LENGTH,
      SEQUENCE_NUMBER_LENGTH,
      this,
      PACKET_TYPE_LENGTH +
        FILE_HASH_LENGTH +
        SEQUENCE_NUMBER_LENGTH +
        this.data.byteLength
    );
    const buffer = new ArrayBuffer(
      PACKET_TYPE_LENGTH +
        FILE_HASH_LENGTH +
        SEQUENCE_NUMBER_LENGTH +
        this.data.byteLength
    );
    const outputView = new DataView(buffer);
    const thisView = new DataView(this.data);
    console.log(buffer, outputView);
    outputView.setUint8(0, this.packetType);
    outputView.setUint32(PACKET_TYPE_LENGTH, this.fileHash, false);
    outputView.setUint32(
      PACKET_TYPE_LENGTH + FILE_HASH_LENGTH,
      this.sequenceNumber,
      false
    );

    for (let i = 0; i < this.data.byteLength; i++) {
      outputView.setUint8(
        PACKET_TYPE_LENGTH + FILE_HASH_LENGTH + SEQUENCE_NUMBER_LENGTH + i,
        thisView.getUint8(i)
      );
    }
    return buffer;
  }

  toBinaryString() {
    return ByteUtils.arrayBufferToString(this.toArrayBuffer());
  }

  static decodeByteArray(bytes) {
    return ByteUtils.byteArrayToArrayBuffer(bytes);
  }

  static decodeArrayBuffer(buffer) {
    console.assert(buffer instanceof ArrayBuffer);
    // const buffer = new Uint8Array(bytes);
    const length = buffer.byteLength;
    if (
      length <
      PACKET_TYPE_LENGTH + FILE_HASH_LENGTH + SEQUENCE_NUMBER_LENGTH
    ) {
      console.log('not enough data to decode', buffer);
      return null;
    }
    const dataView = new DataView(buffer);
    const packet = new Packet();
    packet.packetType = dataView.getUint8(0);
    packet.fileHash = dataView.getUint32(PACKET_TYPE_LENGTH, false);
    packet.sequenceNumber = dataView.getUint32(
      PACKET_TYPE_LENGTH + FILE_HASH_LENGTH,
      false
    );
    packet.data = buffer.slice(
      PACKET_TYPE_LENGTH + FILE_HASH_LENGTH + SEQUENCE_NUMBER_LENGTH
    );

    return packet;
  }

  static decodeBinaryString(binaryString) {
    return this.decodeArrayBuffer(ByteUtils.stringToArrayBuffer(binaryString));
  }

  static generateFileHash() {
    return Math.floor(Math.random() * ByteUtils.UINT32_MAX);
  }

  static encodeInitialPacket(file) {
    const packet = new Packet();
    packet.packetType = Packet.packetTypes.INITIAL_PACKET;
    packet.sequenceNumber = 0;
    packet.fileHash = this.generateFileHash();
    packet.data = new ArrayBuffer(
      TYPE_METADATA_LENGTH + TITLE_METADATA_MAX_LENGTH
    );
    const typeAlignedString = file.type
      .substr(0, TYPE_METADATA_LENGTH)
      .padEnd(TYPE_METADATA_LENGTH, ' ');
    const nameAlignedString = file.name
      .substr(0, TITLE_METADATA_MAX_LENGTH)
      .padEnd(TITLE_METADATA_MAX_LENGTH, ' ');
    const dataArray = new Uint8Array(packet.data);
    dataArray.set(
      typeAlignedString.split('').map((s) => s.charCodeAt(0)),
      0
    );
    dataArray.set(
      nameAlignedString.split('').map((s) => s.charCodeAt(0)),
      TYPE_METADATA_LENGTH
    );
    return packet;
  }

  static encodeDataPacket(fileHash, sequenceNumber, data) {
    const packet = new Packet();
    packet.packetType = Packet.packetTypes.DATA_PACKET;
    packet.fileHash = fileHash;
    packet.sequenceNumber = sequenceNumber;
    packet.data = data.slice(0);
    return packet;
  }

  static encodeAckPacket(fileHash, sequenceNumber) {
    const packet = new Packet();
    packet.packetType = Packet.packetTypes.ACK_PACKET;
    packet.fileHash = fileHash;
    packet.sequenceNumber = sequenceNumber;
    return packet;
  }

  static encodeEofPacket(fileHash, sequenceNumber) {
    const packet = new Packet();
    packet.packetType = Packet.packetTypes.EOF_PACKET;
    packet.fileHash = fileHash;
    packet.sequenceNumber = sequenceNumber;
    return packet;
  }

  extractFileMetadata() {
    const metadata = {};
    if (
      this.data.byteLength >=
      TYPE_METADATA_LENGTH + TITLE_METADATA_MAX_LENGTH
    ) {
      metadata.type = ByteUtils.arrayBufferToString(
        this.data.slice(0, TYPE_METADATA_LENGTH)
      );
      metadata.name = ByteUtils.arrayBufferToString(
        this.data.slice(
          TYPE_METADATA_LENGTH,
          TYPE_METADATA_LENGTH + TITLE_METADATA_MAX_LENGTH
        )
      );
    }
    return metadata;
  }

  toString() {
    let s = '';
    switch (this.packetType) {
      case Packet.packetTypes.INITIAL_PACKET:
        s += 'INITIAL_PACKET';
        s += JSON.stringify(this.extractFileMetadata());
        break;
      case Packet.packetTypes.ACK_PACKET:
        s += 'ACK_PACKET';
        break;
      case Packet.packetTypes.DATA_PACKET:
        s += 'DATA_PACKET';
        break;
      case Packet.packetTypes.EOF_PACKET:
        s += 'EOF_PACKET';
        break;
      default:
        s += 'UNKNOWN_PACKET';
        break;
    }
    s += `(${this.fileHash})`;
    s += `[${this.sequenceNumber}]`;

    s += `: (${this.data.byteLength})[${ByteUtils.arrayBufferToHexString(
      this.data
    )}]`;

    return s;
  }
}

export default Packet;
